import React, { useState, useRef,useEffect } from 'react';
import { Search, Plus, Edit, Trash2, Phone, Building, User, Mail, Calendar, MapPin, CreditCard, X, Check, AlertCircle ,CheckCircle, ChevronDown} from 'lucide-react';
import AddConnection from './AddConnection';
import connectionService from '../services/connectionService';
const ConnectionDetails= () => {
  const [connections, setConnections] = useState([]);
  const [filteredConnections, setFilteredConnections] = useState([]);
  const [numberTypes, setNumberTypes] = useState([]);
  const [connectionOptions, setConnectionOptions] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedConnection, setSelectedConnection] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState('view'); // 'view', 'create', 'edit'
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState(null);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [searchTerms, setSearchTerms] = useState({});
  const [dropdownOpen, setDropdownOpen] = useState({});
  const dropdownRefs = useRef({});
  
  // Sample data for demonstration
  useEffect(() => {
    // Initialize with sample data
     loadUsers();

    const sampleNumberTypes = [
      { id: 1, name: 'Business Line', description: 'Standard business telephone line', active: true },
      { id: 2, name: 'Fax Line', description: 'Dedicated fax line', active: true },
      { id: 3, name: 'Conference Line', description: 'Multi-party conference line', active: true }
    ];

    const sampleConnectionOptions = [
      { id: 1, name: 'Standard', description: 'Standard connection option', active: true },
      { id: 2, name: 'Premium', description: 'Premium connection with enhanced features', active: true },
      { id: 3, name: 'Enterprise', description: 'Enterprise-grade connection', active: true }
    ];
    
      setNumberTypes(sampleNumberTypes);
      setConnectionOptions(sampleConnectionOptions);
   
  }, []);
   const loadUsers = async () => {
      setLoading(true);
      const response = await connectionService.getAllConnections();
      const users = Array.isArray(response.data) ? response.data : [];
     
      setConnections(users);
      setFilteredConnections(users);
     
    };
  const [formData, setFormData] = useState({
    salesman_name: '',
    regulated: 'LIMITED',
    installation_address: '',
    date: '09/01/2025',
    company_reg: '',
    md_name: '',
    position: '',
    companyName: '',
    registeredAddress1: '',
    addressLine2: '',
    addressLine3: '',
    addressLine4: '',
    postcode: '',
    directorEmail: '',
    billingEmail: '',
    bankName: '',
    bankAddress: '',
    bankPostcode: '',
    accountHolder: '',
    accountNumber: '',
    sortCode: '',
    services: [
      { id: 1, description: '', type: 1, existingTel: '', quantity: '', isdn2e: 0, isdn30e: 0, analogue: 0, postcode: '' }
    ]
  });
  const serviceTypes = [
    { value: 1, label: 'Main Voice No., Keep Number and Connect to System' },
    { value: 2, label: 'Main voice No., CNI to 0844, order new DDI to connect to app' },
    { value: 3, label: 'transfer to app' },
    { value: 4, label: 'feature line convert' },
    { value: 5, label: 'Voice No., Keep Outside System' },
    { value: 6, label: 'Voice No. Cease line and number' },
    { value: 7, label: 'Fax. No., Cease Line and Keep Number and Connect to System' },
    { value: 8, label: 'Fax. No. Keep Outside system' },
    { value: 9, label: 'Modem No., Cease Line, Keep Number and Connect to System' },
    { value: 10, label: 'Modem No., Cease Line and and Cease Number and Connect to System' },
    { value: 11, label: 'Modem No., Keep Outside system' },
    { value: 12, label: 'PDQ No., Cease Line and Keep Number and Connect to System' },
    { value: 13, label: 'PDQ No., Cease Line and Cease Number and Connect to System' },
    { value: 14, label: 'PDQ No., Keep Outside system' },
    { value: 15, label: 'Alarm Line, Keep outside system' },
    { value: 16, label: 'ADSL Line, Keep outside system' },
    { value: 17, label: 'Home Worker- Apply CPS/ line rental-please provide post code' },
    { value: 18, label: 'remote site billing only- please provide post code' },
    { value: 19, label: 'Yes Customer has 08 Number' },
    { value: 20, label: 'No Customer has No 08 Number' },
    { value: 24, label: 'Network Only' },
    { value: 25, label: 'Yes Customer has 08 Number' },
    { value: 26, label: 'No Customer has No 08 Number' }
  ];

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: '' }));
    }
  };
   const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    
    setIsSubmitting(true);
    
    // Simulate API call
    await new Promise(resolve => setTimeout(resolve, 2000));
    
    setIsSubmitting(false);
    setSubmitted(true);
    //console.log('Form submitted:', formData);
  };

  const handleServiceChange = (index, field, value) => {
    const updatedServices = [...formData.services];
    updatedServices[index] = { ...updatedServices[index], [field]: value };
    setFormData(prev => ({ ...prev, services: updatedServices }));
  };

  const addService = () => {
    const newService = {
      id: Date.now(),
      description: '',
      type: 1,
      existingTel: '',
      quantity: '',
      isdn2e: 0,
      isdn30e: 0,
      analogue: 0,
      postcode: ''
    };
    setFormData(prev => ({ ...prev, services: [...prev.services, newService] }));
  };

  const removeService = (index) => {
    if (formData.services.length > 1) {
      const updatedServices = formData.services.filter((_, i) => i !== index);
      setFormData(prev => ({ ...prev, services: updatedServices }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.salesman_name.trim()) newErrors.salesman_name = 'Salesman name is required';
    if (!formData.companyName.trim()) newErrors.companyName = 'Company name is required';
    if (!formData.directorEmail.trim()) newErrors.directorEmail = 'Director email is required';
    if (!formData.accountNumber.trim()) newErrors.accountNumber = 'Account number is required';
    if (!formData.sortCode.trim()) newErrors.sortCode = 'Sort code is required';
    
    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (formData.directorEmail && !emailRegex.test(formData.directorEmail)) {
      newErrors.directorEmail = 'Invalid email format';
    }
    if (formData.billingEmail && !emailRegex.test(formData.billingEmail)) {
      newErrors.billingEmail = 'Invalid email format';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Filter connections based on search term
 useEffect(() => {
  if (searchTerm.trim() === '') {
    setFilteredConnections(connections);
  } else {
    const lowerSearch = searchTerm.toLowerCase();
    const filtered = connections.filter(connection =>
      Object.values(connection).some(value =>
        String(value || '').toLowerCase().includes(lowerSearch)
      )
    );
    setFilteredConnections(filtered);
  }
}, [searchTerm, connections]);


  const showNotification = (message, type = 'success') => {
    setNotification({ message, type });
    setTimeout(() => setNotification(null), 3000);
  };

  const handleViewConnection = (connection) => {
    setSelectedConnection(connection);
    setModalMode('view');
    setShowModal(true);
  };

  const handleCreateConnection = () => {
    setSelectedConnection({
      user_detail_id: '',
      salesman_name: '',
      salesman_address: '',
      regulation_status: 'Pending',
      installation_address: '',
      contract_date: '',
      company_reg: '',
      md_name: '',
      position: '',
      company_name: '',
      registered_address_line_1: '',
      registered_address_line_2: '',
      registered_address_line_3: '',
      registered_address_line_4: '',
      postcode: '',
      director_email: '',
      billing_email: '',
      bank_name: '',
      bank_address: '',
      bank_postcode: '',
      account_holder: '',
      account_number: '',
      sort_code: '',
      isdn2e_channels_required: 0,
      isdn30e_channels_required: 0,
      analogue_channels_required: 0,
      telephoneLines: []
    });
    setModalMode('create');
    setShowModal(true);
  };

  const handleEditConnection = (connection) => {
    setSelectedConnection({ ...connection });
    setModalMode('edit');
    setShowModal(true);
  };

  const handleDeleteConnection = (connectionId) => {
    if (window.confirm('Are you sure you want to delete this connection?')) {
      setConnections(prev => prev.filter(conn => conn.id !== connectionId));
      showNotification('Connection deleted successfully');
    }
  };


  const addTelephoneLine = () => {
    const newLine = {
      id: Math.random(),
      connection_detail_id: selectedConnection.id,
      number_type_id: numberTypes[0]?.id || '',
      connection_option_id: connectionOptions[0]?.id || '',
      existing_tel_no: '',
      existing_lines: 1,
      postcode_of_homeworker: '',
      numberType: numberTypes[0] || null,
      connectionOption: connectionOptions[0] || null
    };
    
    setSelectedConnection(prev => ({
      ...prev,
      telephoneLines: [...(prev.telephoneLines || []), newLine]
    }));
  };
   const getSelectedServiceLabel = (value) => {
    const service = serviceTypes.find(type => type.value === value);
    return service ? `${service.value} - ${service.label}` : '';
  };
  const getFilteredServiceTypes = (searchTerm) => {
    if (!searchTerm) return serviceTypes;
    return serviceTypes.filter(type => 
      type.label.toLowerCase().includes(searchTerm.toLowerCase()) ||
      type.value.toString().includes(searchTerm)
    );
  };
   const selectServiceType = (index, type) => {
    handleServiceChange(index, 'type', type.value);
    setSearchTerms(prev => ({ ...prev, [index]: '' }));
    setDropdownOpen(prev => ({ ...prev, [index]: false }));
  };
   const handleSearchChange = (index, searchTerm) => {
    setSearchTerms(prev => ({ ...prev, [index]: searchTerm }));
    setDropdownOpen(prev => ({ ...prev, [index]: true }));
  };

  const removeTelephoneLine = (lineId) => {
    setSelectedConnection(prev => ({
      ...prev,
      telephoneLines: prev.telephoneLines.filter(line => line.id !== lineId)
    }));
  };

  const updateTelephoneLine = (lineId, field, value) => {
    setSelectedConnection(prev => ({
      ...prev,
      telephoneLines: prev.telephoneLines.map(line => {
        if (line.id === lineId) {
          const updatedLine = { ...line, [field]: value };
          if (field === 'number_type_id') {
            updatedLine.numberType = numberTypes.find(nt => nt.id === parseInt(value));
          }
          if (field === 'connection_option_id') {
            updatedLine.connectionOption = connectionOptions.find(co => co.id === parseInt(value));
          }
          return updatedLine;
        }
        return line;
      })
    }));
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'approved': return 'bg-green-100 text-green-800';
      case 'pending': return 'bg-yellow-100 text-yellow-800';
      case 'rejected': return 'bg-red-100 text-red-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-cyan-50 via-white to-blue-50">
      {/* Header */}
      <div className="bg-white shadow-lg border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-6">
            <div className="flex items-center space-x-3">
              <div className="bg-gradient-to-r from-cyan-600 to-blue-600 p-3 rounded-xl">
                <Building className="h-8 w-8 text-white" />
              </div>
              <div>
                <h1 className="text-3xl font-bold bg-gradient-to-r from-cyan-600 to-blue-600 bg-clip-text text-transparent">
                  Customer Details
                </h1>
                <p className="text-gray-600">Manage your business connections and telephone lines</p>
              </div>
            </div>
            
           {/* <button
              onClick={handleCreateConnection}
              className="bg-gradient-to-r from-cyan-600 to-blue-600 hover:from-cyan-700 hover:to-blue-700 text-white px-6 py-3 rounded-xl font-semibold flex items-center space-x-2 transform hover:scale-105 transition-all duration-200 shadow-lg"
            >
              <Plus className="h-5 w-5" />
              <span>Add Customer</span>
            </button>*/}
          </div>
        </div>
      </div>

      {/* Search Bar */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="relative">
          <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
          <input
            type="text"
            placeholder="Search by company name, salesman, MD name, or company registration..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-12 pr-4 py-4 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-transparent shadow-sm bg-white"
          />
        </div>
      </div>

      {/* Connections Grid */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredConnections.map((connection) => (
            <div
              key={connection.id}
              className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 overflow-hidden transform hover:-translate-y-1"
            >
              <div className="bg-gradient-to-r from-cyan-600 to-blue-600 p-4 text-white">
                <div className="flex justify-between items-start">
                  <div>
                    <h3 className="text-xl font-bold mb-1">{connection.company_name}</h3>
                    <p className="text-cyan-100 text-sm">{connection.company_reg}</p>
                  </div>
                  <span className={`px-3 py-1 rounded-full text-xs font-semibold ${getStatusColor(connection.regulation_status)}`}>
                    {connection.regulation_status}
                  </span>
                </div>
              </div>
              
              <div className="p-6">
                <div className="space-y-3 mb-6">
                  <div className="flex items-center space-x-3 text-gray-600">
                    <User className="h-4 w-4 text-cyan-500" />
                    <span className="text-sm">{connection.md_name} - {connection.position}</span>
                  </div>
                  
                  <div className="flex items-center space-x-3 text-gray-600">
                    <Mail className="h-4 w-4 text-blue-500" />
                    <span className="text-sm">{connection.director_email}</span>
                  </div>
                  
                  <div className="flex items-center space-x-3 text-gray-600">
                    <Calendar className="h-4 w-4 text-green-500" />
                    <span className="text-sm">{new Date(connection.contract_date).toLocaleDateString()}</span>
                  </div>
                  
                    {/*<div className="flex items-center space-x-3 text-gray-600">
                    <Phone className="h-4 w-4 text-orange-500" />
                    <span className="text-sm">{connection.telephoneLines?.length || 1} telephone lines</span>
                  </div>*/}
                </div>
                
                <div className="flex space-x-2">
                  <button
                    onClick={() => handleViewConnection(connection)}
                    className="flex-1 bg-cyan-50 hover:bg-cyan-100 text-cyan-600 py-2 px-4 rounded-lg font-medium transition-colors duration-200"
                  >
                    View
                  </button>
                   {/* Connections Grid 
                  <button
                    onClick={() => handleEditConnection(connection)}
                    className="flex-1 bg-blue-50 hover:bg-blue-100 text-blue-600 py-2 px-4 rounded-lg font-medium transition-colors duration-200"
                  >
                    Edit
                  </button>*/}
                  {/* 
                  <button
                    onClick={() => handleDeleteConnection(connection.id)}
                    className="bg-red-50 hover:bg-red-100 text-red-600 py-2 px-4 rounded-lg font-medium transition-colors duration-200"
                  >
                     <Trash2 className="h-4 w-4" />
                  </button>*/}
                </div>
              </div>
            </div>
          ))}
        </div>
        
        {filteredConnections.length === 0 && (
          <div className="text-center py-12">
            <Building className="h-16 w-16 text-gray-300 mx-auto mb-4" />
            <p className="text-gray-500 text-lg">No customers found</p>
            <p className="text-gray-400">Try adjusting your search terms or create a new connection</p>
          </div>
        )}
      </div>

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto shadow-2xl">
            <div className="bg-gradient-to-r from-cyan-600 to-blue-600 p-6 text-white">
              <div className="flex justify-between items-center">
                <h2 className="text-2xl font-bold">
                  {modalMode === 'view' ? 'Connection Details' : 
                   modalMode === 'create' ? 'Create New Connection' : 'Edit Connection'}
                </h2>
                <button
                  onClick={() => setShowModal(false)}
                  className="text-white hover:text-gray-200 transition-colors"
                >
                  <X className="h-6 w-6" />
                </button>
              </div>
            </div>
            
            <div className="p-6">
              {modalMode === 'view' ? (
                <div className="space-y-6">
                  {/* Company Information */}
                  <div className="bg-gray-50 rounded-xl p-6">
                    <h3 className="text-lg font-semibold mb-4 flex items-center">
                      <Building className="h-5 w-5 mr-2 text-cyan-500" />
                      Company Information
                    </h3>
                    <div className="grid grid-cols-2 gap-4 text-sm">
                      <div><strong>Company Name:</strong> {selectedConnection.company_name}</div>
                      <div><strong>Registration:</strong> {selectedConnection.company_reg}</div>
                      <div><strong>MD Name:</strong> {selectedConnection.md_name}</div>
                      <div><strong>Position:</strong> {selectedConnection.position}</div>
                      <div><strong>Director Email:</strong> {selectedConnection.director_email}</div>
                      <div><strong>Billing Email:</strong> {selectedConnection.billing_email}</div>
                    </div>
                  </div>

                  {/* Address Information */}
                  <div className="bg-gray-50 rounded-xl p-6">
                    <h3 className="text-lg font-semibold mb-4 flex items-center">
                      <MapPin className="h-5 w-5 mr-2 text-green-500" />
                      Address Information
                    </h3>
                    <div className="grid grid-cols-1 gap-2 text-sm">
                      <div><strong>Registered Address:</strong></div>
                      <div className="ml-4">
                        {selectedConnection.registered_address_line_1}<br/>
                        {selectedConnection.registered_address_line_2}<br/>
                        {selectedConnection.registered_address_line_3}<br/>
                        {selectedConnection.registered_address_line_4}<br/>
                        {selectedConnection.postcode}
                      </div>
                    </div>
                  </div>

                  {/* Banking Information */}
                  <div className="bg-gray-50 rounded-xl p-6">
                    <h3 className="text-lg font-semibold mb-4 flex items-center">
                      <CreditCard className="h-5 w-5 mr-2 text-blue-500" />
                      Banking Information
                    </h3>
                    <div className="grid grid-cols-2 gap-4 text-sm">
                      <div><strong>Bank Name:</strong> {selectedConnection.bank_name}</div>
                      <div><strong>Account Holder:</strong> {selectedConnection.account_holder}</div>
                      <div><strong>Account Number:</strong> {selectedConnection.account_number}</div>
                      <div><strong>Sort Code:</strong> {selectedConnection.sort_code}</div>
                    </div>
                  </div>

                  {/* Telephone Lines */}
                   {/*
                  <div className="bg-gray-50 rounded-xl p-6">
                    <h3 className="text-lg font-semibold mb-4 flex items-center">
                      <Phone className="h-5 w-5 mr-2 text-orange-500" />
                      Telephone Lines
                    </h3>
                    {selectedConnection.telephoneLines?.length > 0 ? (
                      <div className="space-y-3">
                        {selectedConnection.telephoneLines.map((line) => (
                          <div key={line.id} className="bg-white p-4 rounded-lg border">
                            <div className="grid grid-cols-2 gap-4 text-sm">
                              <div><strong>Number:</strong> {line.existing_tel_no}</div>
                              <div><strong>Type:</strong> {line.numberType?.name}</div>
                              <div><strong>Lines:</strong> {line.existing_lines}</div>
                              <div><strong>Option:</strong> {line.connectionOption?.name}</div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <p className="text-gray-500">No telephone lines configured</p>
                    )}
                  </div>
                  */}
                </div>
              ) : (
                 <AddConnection
                  mode={modalMode}
                  initialData={""}
                  onClose={() => setShowModal(false)}
                />
              )}
            </div>
          </div>
        </div>
      )}

      {/* Notification */}
      {notification && (
        <div className="fixed top-4 right-4 z-50 animate-in slide-in-from-right duration-300">
          <div className={`p-4 rounded-lg shadow-lg flex items-center space-x-3 ${
            notification.type === 'success' 
              ? 'bg-green-500 text-white' 
              : 'bg-red-500 text-white'
          }`}>
            {notification.type === 'success' ? (
              <Check className="h-5 w-5" />
            ) : (
              <AlertCircle className="h-5 w-5" />
            )}
            <span>{notification.message}</span>
          </div>
        </div>
      )}

      {/* Stats Footer */}
      {/* <div className="bg-white border-t border-gray-200 mt-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="bg-gradient-to-r from-cyan-600 to-blue-600 w-12 h-12 rounded-lg flex items-center justify-center mx-auto mb-2">
                <Building className="h-6 w-6 text-white" />
              </div>
              <div className="text-2xl font-bold text-gray-900">{connections.length}</div>
              <div className="text-sm text-gray-500">Total Customers</div>
            </div>
            
            <div className="text-center">
              <div className="bg-gradient-to-r from-green-500 to-cyan-500 w-12 h-12 rounded-lg flex items-center justify-center mx-auto mb-2">
                <Check className="h-6 w-6 text-white" />
              </div>
              <div className="text-2xl font-bold text-gray-900">
                {connections.filter(c => c.regulation_status === 'Approved').length}
              </div>
              <div className="text-sm text-gray-500">Approved</div>
            </div>
            
            <div className="text-center">
              <div className="bg-gradient-to-r from-yellow-500 to-orange-500 w-12 h-12 rounded-lg flex items-center justify-center mx-auto mb-2">
                <AlertCircle className="h-6 w-6 text-white" />
              </div>
              <div className="text-2xl font-bold text-gray-900">
                {connections.filter(c => c.regulation_status === 'Pending').length}
              </div>
              <div className="text-sm text-gray-500">Pending</div>
            </div>
            
            <div className="text-center">
              <div className="bg-gradient-to-r from-blue-500 to-cyan-500 w-12 h-12 rounded-lg flex items-center justify-center mx-auto mb-2">
                <Phone className="h-6 w-6 text-white" />
              </div>
              <div className="text-2xl font-bold text-gray-900">
                {connections.reduce((sum, conn) => sum + (conn.telephoneLines?.length || 0), 0)}
              </div>
              <div className="text-sm text-gray-500">Telephone Lines</div>
            </div>
          </div>
        </div>
      </div>
      */}
    </div>
  );
};

export default ConnectionDetails;